import { useEffect, useRef } from "react";

const NeuralSignalCanvas = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let t = 0;

    const draw = () => {
      const dpr = window.devicePixelRatio || 1;
      const w = canvas.clientWidth;
      const h = canvas.clientHeight;
      const pw = Math.max(1, Math.round(w * dpr));
      const ph = Math.max(1, Math.round(h * dpr));
      if (canvas.width !== pw || canvas.height !== ph) {
        canvas.width = pw;
        canvas.height = ph;
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);
      t += 0.008;

      // Langsom puls mellem uro og ro — signalet sænker sig og finder leje
      const settle = (Math.sin(t * 0.6) + 1) / 2; // 0 = uro, 1 = ro
      const baseAmp = 10 + (1 - settle) * 26;
      const baseFreq = 1.2 + (1 - settle) * 2.2;

      ctx.strokeStyle = "rgba(245,245,240,0.12)";
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(0, h / 2);
      ctx.lineTo(w, h / 2);
      ctx.stroke();

      for (let layer = 0; layer < 3; layer++) {
        ctx.beginPath();
        const amp = baseAmp * (1 - layer * 0.3);
        const freq = baseFreq * (1 + layer * 0.18);
        for (let x = 0; x <= w; x += 2) {
          const p = x / w;
          const env = Math.sin(p * Math.PI);
          const drift = Math.sin(p * 3 + t * 0.9) * (1 - settle) * 8;
          const y =
            h / 2 +
            Math.sin(p * freq * Math.PI * 2 + t * (1.4 + layer * 0.35)) * amp * env +
            drift * env;
          if (x === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        }
        ctx.strokeStyle =
          layer === 0 ? "rgba(245,245,240,0.95)" : `rgba(245,245,240,${0.35 - layer * 0.12})`;
        ctx.lineWidth = layer === 0 ? 1.4 : 1;
        ctx.stroke();
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div data-testid="neural-signal-canvas" className="border border-darkborder bg-obsidian2 p-6 sm:p-10">
      <div className="flex items-center justify-between gap-4 font-mono text-[11px] uppercase tracking-[0.25em] text-[#A3A299]">
        <span>Hjernens elektriske aktivitet</span>
        <span>Levende signal</span>
      </div>
      <div className="relative mt-6 h-48 sm:h-64">
        <canvas ref={canvasRef} className="h-full w-full" />
      </div>
      <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-[#575752]">
        Illustrativ visualisering — ikke en EEG-måling
      </p>
    </div>
  );
};

export default NeuralSignalCanvas;
